import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation';

import FreightRestrictions from '../../components/FreightRestrictions';

export default () => (
  <div>
    <Helmet
      title='Fire Island Ferries | Passenger Freight Policy'
      meta={[
        {
          name: 'description',
          content: 'Fire Island Ferries Passenger Freight Policy',
        },
        {
          name: 'keywords',
          content: 'Fire Island, New York, Long Island, Ferries, Water Taxi',
        },
      ]}
    />
    <Navigation />
    <div className='container page'>
      <div className='heading'>
        <h2>Info</h2>
        <h1>Passenger Freight Policy</h1>
      </div>
      <p>
        Below is the current passenger freight policy. Please plan accordingly!
        For additional information please contact us at{' '}
        <i className='far fa-phone' /> 631.665.3600 or e-mail us at{' '}
        <i className='far fa-envelope' /> info@fireislandferries.com
      </p>
      <FreightRestrictions />
    </div>
  </div>
);
